/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Waiting_Reason_PlaceholderInputs */

const en_task_waiting_reason_placeholder = /** @type {(inputs: Task_Waiting_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a reason`)
};

const pt_br2_task_waiting_reason_placeholder = /** @type {(inputs: Task_Waiting_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o motivo`)
};

/**
* | output |
* | --- |
* | "Select a reason" |
*
* @param {Task_Waiting_Reason_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_waiting_reason_placeholder = /** @type {((inputs?: Task_Waiting_Reason_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Waiting_Reason_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_waiting_reason_placeholder(inputs)
	return pt_br2_task_waiting_reason_placeholder(inputs)
});